import { Directive, HostListener, Input } from "@angular/core";
import { ElementRef } from "@angular/core";

@Directive({
  selector: "[appDigitOnly]",
})
export class DigitOnlyDirective {
  @Input() allowDigitOnly: boolean = true;

  constructor(private el: ElementRef) {}

  @Input() set appConditionalHighlight(condition: boolean) {
    this.allowDigitOnly = condition;
  }

  @HostListener("input", ["$event"]) onInput(event: any) {
    if (!this.allowDigitOnly) {
      console.log(this.allowDigitOnly);
      return;
    }

    const initialValue = this.el.nativeElement.value;
    this.el.nativeElement.value = initialValue.replace(/[^0-9]/g, "");
    if (initialValue !== this.el.nativeElement.value) {
      event.stopPropagation();
    }
  }
}
